<template>
  <div>
    <h2>New mass pending</h2>

    <form @submit.prevent="addPending">

      <div class="form-group">        
        <label for="product">Product (example: @item/stock/m3star)</label>
        <!-- TODO: No element with id product. Click on lable do nothig. Fix it. -->

        <vue-bootstrap-typeahead
          v-model="productAlias"
          :data="suggestions"
          :minMatchingChars="1"
          required
        />
      </div>

      <div class="form-group">
        <label for="amount">Amount</label>
        <input v-model="amount" id="amount" class="form-control" type="number" min="1" required>
      </div>

      <hr>

      <h3>Письмо</h3>

      <p>
        Есть 3 варианта, чтобы указать письмо.
      </p>
      <ol>
        <li>
          Не указывать письмо.
          Т.е. не указывать ни&nbsp;текст письма, ни&nbsp;прототип письма.
          В этом случае будет показан стандартный текст.
        </li>
        <li>
          Указать только текст письма. (Не указывать прототип письма.)<br>
          Максимальная длина текста: 255 символов.
          Это ограничение на длину текста указано в мете (структура <code>DataPending</code>, поле <code>text</code>.)
          В этом варианте нет локализации. Игроки на разных языках увидят одинаковый текст.
        </li>
        <li>
          Указать только прототип письма. (Не указывать текст письма.)
          Этот вариант поддерживает локализацию.
        </li>
      </ol>

      <p class="mb-3">
        Не нужно одновременно указывать и текст, и прототип письма.
      </p>

      <div class="form-group">
        <label for="txt">Letter text (optional)</label>
        <textarea
          v-model="text"
          id="txt"
          class="form-control"
          rows="5"
        />
      </div>

      <div class="form-group">
        <label for="letter">
          Letter proto (optional)<br>
          Alias of prototype ConfPending.<br>
          Example: @pendings/halloween_survey_reward
        </label>
        <input v-model="letter" id="letter" class="form-control">
      </div>

      <hr>

      <div class="form-group">
        <label for="players">Player ids (delimitered with ,)</label>
        <textarea
          v-model="playersIdsStr"
          id="players"
          class="form-control"
          rows="5"
          required
        />
      </div>

      <b-button :to="{name: 'players_pendings'}">Cancel</b-button>

      <delayed-action-button
        type="submit"
        variant="primary"
        :enabled="canInteract"
        :running="adding"
        idleLabel="Create"
        runningLabel="Creating"
      />
    </form>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';
import { parsePlayersIdsDelimitedByComma } from '../model/player.js';

import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue';
import DelayedActionButton from './DelayedActionButton.vue';

export default {
  name: 'PlayersPendingAdd',

  components: {
    VueBootstrapTypeahead,
    DelayedActionButton,
  },

  data() {
    return {
      productAlias: '',
      amount: 1,
      suggestions: [],

      text: '',
      letter: '',

      playersIdsStr: '',

      adding: false,
    };
  },

  computed: {
    canInteract() {
      return !this.adding;
    },
  },

  watch: {
    productAlias(newProductAlias) {
      HTTP.get(
        '/proto_item_aliases/find',
        {
          params: {
            q: newProductAlias
          }
        }
      )
      .then(response => {
        const aliases = [];
        for(var i = 0; i < response.data.data.length; ++i) {
          const alias = response.data.data[i];
          aliases.push(alias);
        }
        this.suggestions = aliases;
      })
      .catch(e => {
        notifier.showError(e.response.data);
      })
    },
  },

  methods: {
    addPending() {
      if(this.adding) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      const normalizedPlayersIdsStrResult = this.getNormalizedPlayersIdsStr();
      if(normalizedPlayersIdsStrResult.error !== null) {
        notifier.showError(normalizedPlayersIdsStrResult.error, {sender: this});
        return;
      }

      this.adding = true;

      const formData = new FormData();
      formData.set('players_ids', normalizedPlayersIdsStrResult.playersIdsStr);
      formData.set('product', this.productAlias);
      formData.set('amount', this.amount);

      const trimmedText = this.text.trim();
      if(trimmedText.length > 0) {
        formData.set('text', trimmedText);
      }

      const trimmedLetter = this.letter.trim();
      if(trimmedLetter.length > 0) {
        formData.set('letter', trimmedLetter);
      }

      HTTP.post('/players/pending/add', formData)
      .then(() => {
        notifier.showSuccessAfterTransition('Pending added.');
        this.$router.push({name: 'players_pendings'});
      })
      .catch(e => {
        this.adding = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    getNormalizedPlayersIdsStr() {
      const playersIdsStrTrimmed = this.playersIdsStr.trim();
      if(playersIdsStrTrimmed.length === 0) {
        return {
          playersIdsStr: null,
          error: new Error('Players ids must be specified.'),
        };
      }

      // Дубликаты допустимы.
      // Это нужно для случая, когда некоторым игрокам нужно выдать предмет несколько раз (т.е. они заплатили несколько раз).
      const playersIdsResult = parsePlayersIdsDelimitedByComma(playersIdsStrTrimmed);
      if(playersIdsResult.error !== null) {
        return {
          playersIdsStr: null,
          error: playersIdsResult.error,
        };
      }

      return {
        playersIdsStr: playersIdsResult.playersIds.join(','),
        error: null,
      };
    },
  },
}
</script>
